import React from 'react';
import { useHistory } from 'react-router';
import Form from '@dashboard/components/Formik/Form';
import { toast } from '@dashboard/context/ToastContext';
import { useCreateTemplateCategory } from '@dashboard/hooks/queries/useAdminMutations';

const TemplateCategoryAdd = () => {
  const history = useHistory();
  const createCategoryMutation = useCreateTemplateCategory();

  return (
    <div className="max-w-xl mx-auto mt-16">
      <h1 className="text-lg font-bold mb-4">Add Template Category</h1>
      <Form
        initialValues={{
          title: '',
          order: '',
          publicTitle: '',
          publicDescription: '',
        }}
        fields={[
          {
            name: 'title',
            required: true,
            type: 'text',
            label: 'Category title',
          },
          {
            name: 'publicTitle',
            required: false,
            type: 'text',
            label: 'Page title',
          },
          {
            name: 'publicDescription',
            required: false,
            type: 'textarea',
            label: 'Page description',
            minRows: 8,
            autosize: true,
          },
          {
            name: 'order',
            required: false,
            type: 'number',
            label: 'Order',
            placeholder: 'Automatically generated if left empty',
          },
        ]}
        showState={false}
        onSubmit={async values => {
          const response = await createCategoryMutation.mutateAsync(values);

          return {
            data: response,
            error: response,
            onSuccess: () => {
              toast({
                title: 'Category added',
              });
              history.push('/admin/template-categories');
            },
          };
        }}
      />
    </div>
  );
};

export default TemplateCategoryAdd;
